import { combineReducers } from '@reduxjs/toolkit'

import { selectionReducer } from './features/duplicates/model/selectionSlice'

/** Состояние модуля `duplicates`: только намерение человека (выбранная карточка). Пары, проверка и отметки — в кэше запросов. */
export const duplicatesUiReducer = combineReducers({ selection: selectionReducer })
export type DuplicatesUiState = ReturnType<typeof duplicatesUiReducer>
